import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RHService from '../../../../../services/rh-auth';



const Concurso = () => {
    const [orgao, setOrgao] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ano, setAno] = useState("");
    const [anoArq, setAnoArq] = useState("");
    const [anexos, setAnexos] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const montaForm = async () => {
        const lic = new FormData();
        lic.append("orgao", orgao)
        lic.append("referencia", referencia)
        lic.append("anoArq", anoArq)
        lic.append("ano", ano)
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await RHService.cadastroConcurso(dados)
            if (lic.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                alert(lic.data["error"])
            }
        } catch (error) {
            alert(error)
        }
    }


    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setOrgao("");
        setReferencia("");
        setAno("");
        setAnoArq("");
        setAnexos([]);
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Orgão">
                                <FloatingLabel
                                    label="Orgão"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Orgão"
                                        name="orgao"
                                        onChange={e => setOrgao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Secretaria Municipal de Saúde">Secretaria Municipal de Saúde</option>
                                        <option value="Secretaria Municipal de Educação">Secretaria Municipal de Educação</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Concurso"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2024">2024</option>
                                        <option value="2010">2010</option>
                                        <option value="2001">2001</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Edital nº"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="number"
                                        name="referencia"
                                        value={referencia}
                                        onChange={e => setReferencia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Edital de Convocação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="AnoArq"
                                        name="anoArq"
                                        onChange={e => setAnoArq(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2001">2001</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="aviso">
                                <Form.Label>Anexos</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="anexos"
                                    onChange={handleUploadDocumentos}
                                    accept=".pdf, .xlsx, .xls"
                                    multiple // Permite múltiplos arquivos
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/rh/concurso'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Documento cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/rh/concurso/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Editais
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/rh/concurso'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Concurso;